<template>
  <el-select
          size="large"
          class="select-primary"
          v-model="newValue"
          value-key="_id"
          filterable
          remote
          reserve-keyword
          :placeholder="placeholder ? placeholder : $t('Type for search...')"
          :multiple="multiple"
          :remote-method="throttledFetch"
          :loading="loading">
    <el-option
            v-for="item in options"
            :key="item._id"
            :label="labelFormat(item)"
            :value="item">
    </el-option>
  </el-select>
</template>

<script>
  import User from '@/store/models/User'
  import Questionnaire from '@/store/models/Questionnaire'
  import Team from '@/store/models/Team'
  import NewsTeam from '@/store/models/NewsTeam'
  import NewsDashboardTeams from '@/store/models/NewsDashboardTeams'
  import { Select, Option } from 'element-ui'
  import isEmpty from 'lodash/isEmpty'
  import throttle from 'lodash/throttle'
  import debounce from 'lodash/debounce'
  import findIndex from 'lodash/findIndex'

  export default {
    name: 'InputPicker',
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      label: {
        type: String
      },
      value: {
        required: true
      },
      dataType: {
        type: String,
        required: true,
        validator: value => ['user', 'questionnaire', 'team', 'newsTeam', 'newsDashboardTeams'].indexOf(value) !== -1
      },
      multiple: {
        type: Boolean,
        default: false
      },
      filter: {
        type: Function
      },
      prefetch: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String
      }
    },
    data () {
      return {
        newValue: [],
        loading: false,
        options: [],
        throttledFetch: throttle(this.remoteMethod.bind(this), 1000),
        debouncedPrefetch: debounce(this.prefetchMethod.bind(this), 1000)
      }
    },

    async mounted () {
      this.handleValueChange()

      if (this.prefetch) {
        await this.debouncedPrefetch()
      }
    },
    methods: {
      handleValueChange (){
        if (!isEmpty(this.value)) {
          this.newValue = this.value
        }
      },
      async apiCall (params) {
        const name = this.dataType.toLowerCase()
        let constantPrefix = []
        let result

        if (name === 'user') {
          result = await User.api().get('/user', { params, save: false })
        } else if (name === 'questionnaire') {
          result = await Questionnaire.api().get('/questionnaire', { params, save: false })
        } else if (name === 'team') {
          result = await Team.api().get('/team', { params, save: false })
        } else if (name === 'newsteam') {
          result = await NewsTeam.api().get('/news/teams', { params, save: false })
        } else if (name === 'newsdashboardteams') {
          constantPrefix = [{_id: "global", title: "Global"}]
          result = await NewsDashboardTeams.api().get('/newsDashboardTeams', { params, save: false })
        }

        if (result) {
          const items = result.response.data.items
          if (this.value && this.value.hasOwnProperty('_id')) {
            const index = findIndex(items, item => item._id === this.value._id)
            if (index === -1) {
              items.unshift(this.value)
            }
          }
          if (this.filter) {
            return items.filter(this.filter)
          }
          return [...constantPrefix, ...items]
        }
        return []
      },
      labelFormat: function (item) {
        switch (this.dataType.toLowerCase()) {
          case 'user':
            return this.$options.filters.formatUser(item)
          case 'questionnaire':
            return this.$options.filters.languageString(item.title)
          case 'team':
          case 'newsteam':
          case 'newsdashboardteams':
            return item.title
          default:
            return item.label
        }
      },
      async prefetchMethod () {
        this.loading = true
        this.options = await this.apiCall({ l: 10 })
        this.loading = false
      },
      async remoteMethod (query) {
        if (query !== '') {
          this.loading = true
          this.options = await this.apiCall({search: query})
          this.loading = false
        } else {
          this.options = []
        }
      }
    },
    watch: {
      newValue () {
        this.$emit('input', this.newValue)
      },
      value () {
        this.handleValueChange()
        if (this.value === '') {
          this.newValue = ''
        }
      },
      dataType () {
        this.newValue = ''
        this.$emit('input', this.newValue)
        this.remoteMethod()
      }
    }
  }
</script>
